define.alias("shared/components/shared/ui/accordion-item", "calendar/components/shared/ui/accordion-item");